import { Action } from '@ngrx/store';

export const GET_USERS = 'GET_USERS';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = 'GET_USERS_FAILURE';

export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE';

export const GET_USERS_STATS = 'GET_USERS_STATS';
export const GET_USERS_STATS_SUCCESS = 'GET_USERS_STATS_SUCCESS';
export const GET_USERS_STATS_FAILURE = 'GET_USERS_STATS_FAILURE';

export const SET_BLOCK_INCOMING_CALLS = 'SET_BLOCK_INCOMING_CALLS';

export class GetUsersAction implements Action {
  readonly type = GET_USERS;

  constructor() {}
}

export class GetUsersSuccessAction implements Action {
  readonly type = GET_USERS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetUsersFailureAction implements Action {
  readonly type = GET_USERS_FAILURE;

  constructor(public payload: any) {}
}

export class GetCurrentUserAction implements Action {
  readonly type = GET_CURRENT_USER;

  constructor() {}
}
export class GetCurrentUserSuccessAction implements Action {
  readonly type = GET_CURRENT_USER_SUCCESS;

  constructor(public payload: any) {}
}
export class GetCurrentUserFailureAction implements Action {
  readonly type = GET_CURRENT_USER_FAILURE;

  constructor(public payload: any) {}
}

export class GetUsersStatsAction implements Action {
  readonly type = GET_USERS_STATS;

  constructor() {}
}

export class GetUsersStatsSuccessAction implements Action {
  readonly type = GET_USERS_STATS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetUsersStatsFailureAction implements Action {
  readonly type = GET_USERS_STATS_FAILURE;

  constructor(public payload: any) {}
}

export class SetBlockIncomingCalls implements Action {
  readonly type = SET_BLOCK_INCOMING_CALLS;

  constructor(public payload: any) {}
}
export type UsersAction =
  | GetUsersAction
  | GetUsersSuccessAction
  | GetUsersFailureAction
  | GetUsersStatsAction
  | GetUsersStatsSuccessAction
  | GetUsersStatsFailureAction
  | SetBlockIncomingCalls
  | GetCurrentUserAction
  | GetCurrentUserSuccessAction
  | GetCurrentUserFailureAction;
